var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-9.1%",
    y: "-4.5%",
    width: "118.2%",
    height: "118.2%",
    filterUnits: "objectBoundingBox",
    id: "lotwg3oeha"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 11.192v-.384C0 4.84 4.84 0 10.808 0h.384C17.16 0 22 4.84 22 10.808v.384C22 17.16 17.16 22 11.192 22h-.384C4.84 22 0 17.16 0 11.192z",
    id: "d07cmgod9b"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#lotwg3oeha)",
    xlinkHref: "#d07cmgod9b"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#F6B119",
    xlinkHref: "#d07cmgod9b"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeWidth: 1.118
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 14.793V7.207M8.366 10.968h7.331"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon);
export default __webpack_public_path__ + "static/media/add_icon.656ea1854772f5edab1c043f516d59eb.svg";
export { ForwardRef as ReactComponent };